import UploadRow from "../uploadRow";
import {
    useGetKeysProgress,
    useGetLeveUp,
    usePostStarLevelUpAnimation,
    usePostLevelUpAvatar, usePostLevelUpSound
} from "../../../../../_metronic/api/hooks";
import React, {useEffect, useState} from "react";
import {AnimationAudio, Avatar, StarLevel, StarReport} from "../../../../../_metronic/models";
import Loading from "../../../../../_metronic/layout/components/loading/Loading";
import {toast} from "react-toastify";

const LevelUp = () => {
    const {data, isLoading} = useGetLeveUp()
    const [activeStarType, setActiveStarType] = useState<StarReport>()
    const [activeStarLevel, setActiveStarLevel] = useState<{ name:string, data:StarLevel }>()
    const [activeLevel, setActiveLevel] = useState<{ name:string, data:AnimationAudio }>()
    const [selectedAvatar, setSelectedAvatar] = useState<Avatar>()

    const {mutate:mutateChangeAvatar} = usePostLevelUpAvatar()
    const {mutate:mutateAnimation} = usePostStarLevelUpAnimation()
    const {mutate:mutateSound} = usePostLevelUpSound()

    const handleChangeStarAnimation = (file:File) => {
        const formData = new FormData();
        formData.append('type', `${activeStarType?.type}`);
        formData.append('level', `${activeStarLevel?.name}`);
        formData.append('file', file);
        mutateAnimation(formData, {
            onSuccess: () => {
                toast.success("Register-Audio-Animation successfully uploaded");
            },
            onError: () => {
                toast.error("file was not successfully uploaded, try again")
            }
        })
    }
    const handleChangeAvatarAudio = (file:File) => {
        const formData = new FormData();
        formData.append('level', `${activeLevel?.name.split("_")[1]}`);
        formData.append('file', file);
        mutateSound(formData, {
            onSuccess: () => {
                toast.success("Register-Audio-Animation successfully uploaded");
            },
            onError: () => {
                toast.error("file was not successfully uploaded, try again")
            }
        })
    }
    const handleChangeAvatar = (file:File) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('avatar_id',` ${selectedAvatar?.id}`);
        mutateChangeAvatar(formData, {
            onSuccess: () => {
                toast.success(`${activeStarLevel?.name}  Audio Animation successfully uploaded`);
            },
            onError: () => {
                toast.error("file was not successfully uploaded, try again")
            }
        })
    }
    useEffect(() => {
        if(data) {
            setActiveStarType(Object.entries(data.stars_report)[0][1])
            setActiveStarLevel({name:'1', data:Object.entries(data.stars_report)[0][1].levels['1']})
            setActiveLevel({name:'level_1', data:Object.entries(data.animation_audio_links)[0][1]})
            setSelectedAvatar(data?.avatars_report[0])
        }
    }, [data]);
    if (isLoading) return <div className="w-100 py-20 d-flex align-items-center justify-content-center"><Loading/></div>
    return <div className="w-100 d-flex flex-column">
        <h3 className="mb-5">Select Star Type</h3>
        <div className="d-flex w-100 justify-content-between gap-5 mb-10">
            {
                data && Object.entries(data.stars_report).map(([name, starData]) =>(
                    <button
                        key={name}
                        className={`btn border border-2 btn-light w-100 ${activeStarType?.type === starData.type && "btn-primary"}`}
                        onClick={() => setActiveStarType(starData)}
                    >
                        {name}
                    </button>
                ))
            }

        </div>
        <h3 className="mb-5">Select Star Level Up Type</h3>
        <div className="d-flex w-100 justify-content-between gap-5 mb-10">
            {
                activeStarType && Object.entries(activeStarType.levels).map(([name, levelData]) =>(
                    <button
                        key={name}
                        className={`btn border border-2 btn-light w-100 ${activeStarLevel?.name === name && "btn-primary"}`}
                        onClick={() => setActiveStarLevel({name:name, data:levelData})}
                    >
                        {activeStarType?.type} Level {name}
                    </button>
                ))
            }
        </div>
        <UploadRow title={`${activeStarType?.type} Star Level ${activeStarLevel?.name} Animation`} accept=".json" onUpload={handleChangeStarAnimation} className="mt-5" isExists={activeStarLevel?.data.has_animation}/>


        <h3 className="mb-5 mt-10">Select Level Up Type</h3>
        <div className="d-flex w-100 justify-content-between gap-5 mb-10">
            {
                data && Object.entries(data.animation_audio_links).map(([name, levelData]) =>(
                    <button
                        key={name}
                        className={`btn border border-2 btn-light w-100 ${activeLevel?.name === name && "btn-primary"}`}
                        onClick={() => setActiveLevel({name:name, data:levelData})}
                    >
                        {name}
                    </button>
                ))
            }

        </div>
        <UploadRow title={`${activeLevel?.name}  Audio Animation`} accept="audio/*" onUpload={handleChangeAvatarAudio} className="mt-5" isExists={activeLevel?.data.exists}/>

        <h3 className="mb-5 mt-8">Select Avatar</h3>
        <div className="d-flex flex-wrap gap-5 py-5">
            {data && data?.avatars_report.map( a =>
                <div key={a.title}
                     onClick={()=> setSelectedAvatar(a)}
                     className={`d-flex align-items-center justify-content-center rounded-circle border border-2 border-primary w-90px h-90px cursor-pointer ${selectedAvatar?.id === a.id && "border-success"}`}><p className="mb-0" style={{fontSize: '12px', textAlign:'center'}}>{a.title}</p></div>)}
        </div>

        <UploadRow title="Avatar-Animation" accept=".json" onUpload={handleChangeAvatar} className="mt-5" isExists={selectedAvatar?.has_animation}/>
    </div>
}
export default LevelUp